<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="header-landing-page-button-container">
        <header class="header-landing-page-button" :style="style">
            <div class="header-landing-page-button__inner">
                <div class="header-landing-page-button__top">
                    <component
                        :is="visualHeadings ? 'span' : 'h1'"
                        v-if="title"
                        class="header-landing-page-button__heading u-heading-1"
                    >
                        {{ decodeHtmlEntities(title) }}
                    </component>
                </div>
                <div
                    v-if="ctaBlock"
                    class="header-landing-page-button__content"
                >
                    <div class="header-landing-page-button__left">
                        <slot name="visual"></slot>

                        <div
                            v-if="ctaBlock"
                            class="header-landing-page-button__form"
                        >
                            <div
                                v-if="ctaBlockOverwrite.heading || ctaBlock.heading"
                                class="header-landing-page-button__cta-title u-heading-5"
                            >
                                {{ ctaBlockOverwrite.heading || ctaBlock.heading }}
                            </div>

                            <div class="header-landing-page-button__cta-questions">
                                <div
                                    v-if="ctaBlock.question"
                                    class="header-landing-page-button__question u-heading-3 u-bold"
                                >
                                    {{ ctaBlock.question }}
                                </div>

                                <div
                                    :class="[
                                        'header-landing-page-button__button-container',
                                        {
                                            'header-landing-page-button__button-container--always-double': ctaBlock.questionButtonLayout,
                                        }
                                    ]"
                                >
                                    <DsAtomButton
                                        v-for="button in ctaBlock.buttons"
                                        :key="button.text"
                                        size="medium"
                                        class="header-landing-page-button__button"
                                        :icon-right="button.icon"
                                        :full-width="true"
                                        @click="submitForm(button)"
                                    >
                                        <template #text="{ classes }">
                                            <div
                                                :class="[classes, 'mp-button__text--default header-landing-page-button__button-text']"
                                                v-html="button.text"
                                            ></div>
                                        </template>
                                    </DsAtomButton>
                                </div>

                                <div
                                    v-if="ctaBlock.questionInformation"
                                    class="header-landing-page-button__question-information u-tiny-text"
                                >
                                    {{ ctaBlock.questionInformation }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="ctaBlock && ctaBlock.usps"
                        class="header-landing-page-button__usps"
                    >
                        <WatsonOrganismContentColumnCheckmarks
                            :content="{}"
                            :items="ctaBlock.usps.items"
                            column-count="1"
                            :turn-on-background="false"
                            :background="null"
                            :icon-color="ctaBlock.usps.iconColor"
                            :text-color="ctaBlock.usps.textColor"
                            :typography="ctaBlock.usps.typography"
                            media-position="next-to-text"
                        />
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>

<script setup>
import { DsAtomButton } from '@leads.io/design-system-component-library/marketplaces';

import WatsonOrganismContentColumnCheckmarks from '@organisms/content-column-checkmarks/watson-organism-content-column-checkmarks.vue';
import { handleClickAction } from '@utils/click-action';
import decodeHtmlEntities from '../../../js/utils/decode-html-entities';
import { computed } from 'vue';

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: null,
    },
    subtitle: {
        type: String,
        required: false,
        default: '',
    },
    visualHeadings: {
        type: Boolean,
        required: false,
        default: false,
    },
    ctaBlock: {
        type: Object,
        required: false,
        default: null,
    },
    ctaBlockOverwrite: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    background: {
        type: String,
        required: false,
        default: null,
    },
    backgroundForm: {
        type: String,
        required: false,
        default: null,
    },
    textColor: {
        type: String,
        required: false,
        default: null,
    },
});

const submitForm = button => {
    handleClickAction(props.ctaBlock.clickAction, button.value);
};

const style = computed(() => ({
    '--question-color': props.ctaBlock.style.questionColor || 'initial',
    '--question-information-color': props.ctaBlock.style.questionInformationColor || 'initial',
    '--background-form': props.ctaBlock.style.backgroundForm || 'initial',
    '--background': props.background || 'initial',
    '--text-color': props.textColor || 'initial',
}));
</script>

<style lang="scss">
@use 'watson-organism-header-landing-page-button';
</style>
